module.exports = __webpack_public_path__ + "img/userConfirmation-h.bd4c1ec0.svg";